import { Link } from 'react-router-dom'
import Seo from '../../components/Seo'
import { hero, method, processSteps } from '../../content'

export default function HowItWorks() {
  return (
    <>
      <Seo title="Approach" />
      <section className="hero">
        <span className="eyebrow">Approach</span>
        <h1 style={{ marginTop: '0.75rem' }}>A disciplined process, run the same way every time</h1>
        <p className="lede">
          Sourcing outcomes depend on process quality: who is asked, what they are asked, and how the answers are
          compared. Ours is consistent by design, from the first supplier contact to the executed agreement.
        </p>
      </section>

      <section className="section">
        <ol className="ledger three">
          {processSteps.map((s, i) => (
            <li className="ledger-row" key={s.name}>
              <span className="idx" aria-hidden="true">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3>{s.name}</h3>
              <p className="what">{s.detail}</p>
            </li>
          ))}
        </ol>
      </section>

      <section className="section" aria-labelledby="method-title">
        <div className="section-head">
          <span className="eyebrow">{method.eyebrow}</span>
          <h2 id="method-title">{method.title}</h2>
          <p className="lede">{method.lede}</p>
        </div>
        <div className="facts">
          {method.facts.map((f) => (
            <div className="fact" key={f.eyebrow}>
              <span className="eyebrow">{f.eyebrow}</span>
              <strong>{f.value}</strong>
              <p className="muted">{f.note}</p>
            </div>
          ))}
        </div>
        <p className="muted" style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
          Suppliers who have received our outreach can find details on how to respond, and how to opt out, on the{' '}
          <Link to="/privacy#outreach">privacy and data use page</Link>.
        </p>
      </section>

      <section className="section">
        <div className="section-head">
          <span className="eyebrow">Next step</span>
          <h2>Discuss a category or a renewal</h2>
        </div>
        <Link to="/contact" className="btn">
          {hero.primaryCta}
        </Link>
      </section>
    </>
  )
}
